import { atom } from "recoil";
import { CONSTANTS } from "src/constants";

export const loadingState = atom<boolean>({
  key: "loadingState",
  default: CONSTANTS.COMMON_CONSTANTS.STOP_LOADER,
});
